import { Grid, Group, Layout, Page, Table } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, usePopup, useResource, useStore, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { APIS, SF_IQS_FORM} from "@/tra/tancis/ptli/mypage/myiqs/services/ptliElectrptIqsService";
import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/*
 * Common Code Valid Value Details
 * !== 공통 코드 유효 값 상세 ==!
 */
export const PTLI03040003S = () => {
    const {pgeUid, menuId} = usePage({
        auth: ["auth_ptli0019"],
    });
    const {close, postMessage, getParams} = usePopup();
    const params = getParams();
    const { t } = useTranslation();
    const toast = useToast();
    const [ iqsSbjctlList, setIqsSbjctList]= useState<sbjct[]>();
    const [ iqsTrgtList, setIqsTrgtList]= useState<trgt[]>();
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    interface IQS {
        comnCd : string,
        trgtDispYn : string,
        docCdVal : string,
        iqsSbjctlList? : sbjct[],
        iqsTrgtList? : string[],
    }

    // Subject of Converstion Topic !== IQS 주제항목 ==!
    interface sbjct {
        iqsUuid : string,
        iqsSbjctlSn : number,
        iqsSbjctlLblNm : string,
        iqsSbjctlValue : string,
        iqsSbjctlTpCd : string,
        comnCd : string,
        defaultValue? : string,
        editable? : any,
        required? : any,
        options : comnCdOptions[],
    }

    // IQS Target List !== IQS 대상자 목록 ==!
    interface trgt {
        usrId : string,
        iqsUuid? : string,
    }

    interface comnCdOptions {
        label : string,
        value : string,
    }

    const form = {
        iqsForm: useForm({
            defaultSchema: SF_IQS_FORM,
            defaultValues: { ...pgeStore?.form } || {},
        }),
    };
    
    const fetch = {
        // Query child list for each common code  !== 각 공통코드 별 자식 List 조회 ==!
        selectChildListByComnCd: useFetch({
            api: () => APIS.selectChildListByComnCd(params),
            enabled: false,
            onSuccess: (data) => {
                try {
                    const apiData = data.iqsMgmtInfo?.content.iqsSbjctlList;
                    const newParamList = JSON.parse(JSON.stringify(params?.iqsSbjctlList)) || [];
    
                    apiData.forEach((apiItem: any) => {
                        // Verify that there is a comnCdChildList for each element in the apiData array.
                        // !== apiData 배열의 각 요소에 대해 comnCdChildList가 있는지 확인합니다. ==!
                        if (apiItem.comnCdChildList) {
                            // !== Repeat the comnCdChildList array to find elements with the same comnCd value. ==!
                            // comnCdChildList 배열을 반복하여 comnCd 값이 같은 요소를 찾습니다.
                            apiItem.comnCdChildList.forEach((childItem: any) => {
                                const matchingParam = newParamList.find((paramItem: any) => paramItem.comnCd === childItem.comnCd);
                                // Find elements in the param?.iqsSbjctlList array where comnCd matches.
                                // !== params?.iqsSbjctlList 배열에서 comnCd가 일치하는 요소를 찾습니다. ==!
                                if (matchingParam) {
                                    if (!matchingParam.options) {
                                        matchingParam.options = [];
                                    }
                                    matchingParam.options.push({ label: childItem.cdVldValNm, value: childItem.cdVldVal });
                                }
                            });
                        }
                    });
                    setIqsSbjctList(newParamList);

                    newParamList.forEach((item: any,index : number) => {
                        console.log(item)
                        let type = "";
                        switch (item.iqsSbjctlTpCd) {
                            case "T":
                                type = "text";
                                break;
                            case "C":
                                type = "select";
                                break;
                            case "D":
                                type = "date";
                                break;
                            default:
                                break;
                        }
                        form.iqsForm.setSchema(`d-${index}`, {
                            label: item.iqsSbjctlLblNm,
                            type: type,
                            options:item.options,
                            required : (item.required === "true"||item.required === true) ? true : false,
                            edit : (item.editable === "false"||item.editable === false) ? false : true
                        })
                        form.iqsForm.setValue(`d-${index}`,item.defaultValue);
                    });
                    
                } catch (error) {
                    console.log(error)
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

        saveIQSInfo: useFetch({
            api: () => APIS.saveIQSInfo({
                comnCd : params.comnCd,
                trgtDispYn : params.trgtDispYn,
                docCdVal : params.docCdVal,
                bsopId : params.bsopId,
                iqsSbjctlList : iqsSbjctlList,
                iqsTrgtList : iqsTrgtList,
            }),
            enabled: false,
            onSuccess: (data) => {
                postMessage({result : data?.iqsMgmtInfo});
                close();
            },
            onError: (e) => toast.showToast({ type: "error", content: e.response.data.errorMessage }),
        }),
    };

    const handler = {
        // Initial value setting !== 초기값 세팅 ==!
        setInit: () => {
            if(params.iqsSbjctlList?.length === 0){
                console.log(t("msg.ptl.00265"),{ 0: "T_IQS_SBJT_CREATE" })// {0} is a required field. !== {{0}}은 필수 입력사항입니다.. ==!
            } else {
                // The common code module method requires all comnCd to be used in the form via useResource
                // >> Look up each comnCd's Child List from the parent window
                // 공통 코드 모듈 방식으로는 useResource 를 통해서 form에서 사용할 모든 comnCd를 알고있어야함
                // >> 부모창에서 넘어온 각 comnCd의 자식 List 조회
                fetch.selectChildListByComnCd.fetch();
            }
            if(comnUtils.isEmpty(params.docCdVal)){
                console.log(t("msg.ptl.00265"),{ 0: "L_DOC_CD" })// {0} is a required field. !== {{0}}은 필수 입력사항입니다.. ==!
            }
            if(comnUtils.isEmpty(params.bsopId)){
                console.log(t("msg.ptl.00265"),{ 0: "L_BSOP_ID" })// {0} is a required field. !== {{0}}은 필수 입력사항입니다.. ==!
            }
            if(!params.iqsTrgtList){
                console.log(t("msg.ptl.00265"),{ 0: "T_IQS_TRGT" })// {0} is a required field. !== {{0}}은 필수 입력사항입니다.. ==!
            } else {
                const loginId = auth.get("usrId");
                // Change TargetList Management Type String [] -> trgt[] !== TargetList 관리 형태 변경 String [] -> trgt[] ==!
                const newTrgtList = params.iqsTrgtList?.map((item : any) => (
                    { usrId : item.trim() }
                ));
                if (!newTrgtList.some((item : any) => item.usrId === loginId)) {
                    newTrgtList.push({ usrId: loginId });
                }
                setIqsTrgtList(newTrgtList);
                
            }
            
            
        },
        
        // Click the Save button !== 저장 버튼 클릭 ==!
        clickSaveBtn: () => {
            form.iqsForm.handleSubmit(
                () => {
                    const updatedList = Array.isArray(iqsSbjctlList) ? [...iqsSbjctlList] : [];
                    updatedList.map((item,index) => {
                        const value = form.iqsForm.getValue(`d-${index}`);
                        item.iqsSbjctlValue = value;
                    })
                    setIqsSbjctList(updatedList);
                    fetch.saveIQSInfo.fetch();
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },

    };

    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Header>
                            <Group.Title title={t("T_IQS_SBJT_CREATE")}/>
                        </Group.Header>
                    </Group.Section>
                    <Group.Section>
                        {iqsSbjctlList &&(
                            <>
                                {iqsSbjctlList.map((obj: any, index: any) => (
                                    index % 2 === 0 && <Group.Row key={index}> {/* Use index %2 to hold two each !== 2개씩 담기 위해 index % 2를 사용 ==!*/}
                                        <>
                                            <Group.Control {...form.iqsForm.schema[`d-${index}`]} />
                                            {index + 1 < iqsSbjctlList.length &&
                                                <Group.Control {...form.iqsForm.schema[`d-${index+1}`]} />
                                            }
                                        </>
                                    </Group.Row>
                                ))}
                            </>
                        )}
                    </Group.Section>
                    {params.trgtDispYn === 'Y' &&(
                        <Group.Section>
                            <Group.Header>
                                <Group.Title title={t("T_IQS_TRGT")}/>
                            </Group.Header>
                            <Group.Row>
                                {iqsTrgtList && iqsTrgtList.map((item : any, index : number) => (
                                    <Group.Col key={index.toString()} colSize={1}>{item.usrId}</Group.Col>
                                ))}
                            </Group.Row>
                        </Group.Section>
                    )}
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"save"} onClick={handler.clickSaveBtn} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
